import { render, staticRenderFns } from "./ve-table-submaterials.vue?vue&type=template&id=4fb29f30"
import script from "./ve-table-submaterials.vue?vue&type=script&lang=js"
export * from "./ve-table-submaterials.vue?vue&type=script&lang=js"
import style0 from "./ve-table-submaterials.vue?vue&type=style&index=0&id=4fb29f30&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports